import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { App } from './App';
import { Home } from './home/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.Fragment>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter forceRefresh={true} >
                <Routes>
                    <Route path='/' element={<App />}>
                        <Route path='/' element={<Home />}>
                            <Route path='/organizations/:organizationId' element={<Home />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    </React.Fragment>
);
